import React, { Component } from 'react';
import PriceMsg from '../map'

class Rules extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  render() {
    const { app,appRules,activityDate } = this.props;
    const count = appRules.country === 'KE' || appRules.country === 'MX' ? 2 : 3;
    const rulesMain = (PriceMsg[app] && PriceMsg[app].rulesMain(activityDate,count)) || PriceMsg['default'].rulesMain(activityDate,count)
    return <div className="log-box prize-rules">
      <h2 className="log-box-title">
        <span className="log-box-title_left"></span>
        <span className="log-box-title_right"></span>
        { (PriceMsg[app] && PriceMsg[app].prizeRulesTitle) || PriceMsg['default'].prizeRulesTitle }
      </h2>
      <div className="log-box-content">
        <div dangerouslySetInnerHTML = {{ __html:rulesMain }}></div>
      </div>
    </div>
  }
}

export default Rules;
